import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWebcam: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconWebcam"><Path d="M6.5 21.5H17.5M12 21.5V17.75M12 17.5C16.1421 17.5 19.5 14.1421 19.5 10C19.5 5.85786 16.1421 2.5 12 2.5C7.85786 2.5 4.5 5.85786 4.5 10C4.5 14.1421 7.85786 17.5 12 17.5ZM15.5 10C15.5 11.933 13.933 13.5 12 13.5C10.067 13.5 8.5 11.933 8.5 10C8.5 8.067 10.067 6.5 12 6.5C13.933 6.5 15.5 8.067 15.5 10Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconWebcam;
